// @noflow
import React from 'react'

import { WhereToStartProps } from '@/components/modals/components/WhereToStart/WhereToStart'
import ModalTrigger from '@/components/modals/trigger'

import STYLES from './WhereToStartModalTrigger.module.sass'

const WhereToStartModalTrigger = ({ data }: WhereToStartProps): JSX.Element => (
  <ModalTrigger
    align="center"
    className={STYLES.container}
    modalId="where-to-start-modal"
    text={{
      text: 'where_to_start.trigger.title',
      namespace: 'modals',
      margin: false
    }}
    backgroundColor="brandYellow100"
    screenIdentifier="homeScreen"
    modalOptions={{ data }}
  />
)

export { WhereToStartModalTrigger }
